import { ComparatorStep } from '@kizi/comparator-core';

const comparison: ComparatorStep = {
  path: 'comparison',
  name: 'productComparison',
  fields: [],
};

export default comparison;
